import { client } from './client';

export const dataCaptureForm = ({ topic, email = '', salesSubChannel = '' }) =>
  client('data-capture-form', {
    method: 'POST',
    body: {
      topic,
      channel: 'nep',
      emailAddress: email,
      additionalInformation: {
        journey: salesSubChannel
      }
    }
  });
